import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

import { PAYROLL_RUNS_OPEN_STATUSES } from "../constants";

/**
 * The payroll run that speaks for a pay period.
 *
 * A period can hold more than one run: the on-cycle run that closed, plus any
 * off-cycle run created to pay what it left behind. A run that can still absorb
 * a work log wins — otherwise a work log keeps reading as "approval expired"
 * against the closed run immediately after the payer created the off-cycle run
 * the expired alert asked them to create.
 *
 * Falls back to the first run for the period, so a period whose only run is
 * closed still has a nameable run rather than reading as having none.
 */
export const selectorPayrollRunForPayPeriod = ({
  payrollRuns,
  payPeriodId
}: {
  payrollRuns: PayrollRun[] | undefined;
  payPeriodId: string | null | undefined;
}): PayrollRun | undefined => {
  if (!payPeriodId) {
    return undefined;
  }

  const periodRuns = (payrollRuns ?? []).filter(
    run => run.payPeriodId === payPeriodId
  );

  return (
    periodRuns.find(
      run => !!run.status && PAYROLL_RUNS_OPEN_STATUSES.includes(run.status)
    ) ?? periodRuns[0]
  );
};
